import React, { useState, useEffect, useRef } from "react";

import {
    Button,
    Dialog,
    Grid,
    Icon,
    Typography,
    FormHelperText,
    TextField,
    IconButton
} from "@material-ui/core";
// import Chip from '@material-ui/core/Chip';
// import { makeStyles } from '@material-ui/core/styles';
import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";
import DialogLoader from "../../../../../../components/Loader/DialogLoader";
import {
    InputBaseField, MultiSelectField, FileInput, SelectField
} from "../../../../../../components/InputField/InputField";
import {
    Label,
    DraggableComponent,
} from "../../../../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../../../../Services/APIService";
import { withSnackbar } from "../../../../../../components/Message/Alert";
import useStyles from "./styles";
import {
    allowedAttachmentsImages
} from "../../../../../../../src/components/Common/Extensions";


import PreviewIcon from '@material-ui/icons/Visibility';

function AddGrant({
    dialogOpenClose,
    editProgram,
    handleClose,
    handleSuccessClose,
    programData,
    ...props
}) {
    const classes = useStyles();
    // const classes1 = useStyles1();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState([]);
    const [errorMessages, setErrorMessages] = useState({
        errorNote: false,
        errorEditorMaxValue: false,
    });

    const { showMessage } = props;

    const handleChange = (e) => {

        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const commonAttachments = allowedAttachmentsImages();
    const [bannerImage, setBannerImage] = useState([]);
    const inputFile = useRef(null);

    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0) return;
        const selectedFile = e.target.files[0];
        if (bannerImage.some((file) => file.fileToSend.name === selectedFile.name)) {
            showMessage('Error', 'File already added', 'error', 3000);
            e.target.value = null;
            return;
        }
        const name = selectedFile.name;
        const lastDot = name.lastIndexOf('.');
        const ext = name.substring(lastDot + 1).toLowerCase(); // Convert to lowercase for case-insensitive comparison
        switch (ext) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                break;
            default:
                showMessage(
                    'Error',
                    'File format is not allowed,\n Only files with the following extensions are allowed: .jpg .jpeg .png .gif',
                    'error',
                    3000
                );
                e.target.value = null;
                return;
        }

        setBannerImage((prevImages) => [
            ...prevImages,
            {
                file: URL.createObjectURL(selectedFile),
                fileToSend: selectedFile,
                fileName: selectedFile.name,
            },
        ]);

        e.target.value = null;
    }
    const handleRemoveFile = (index) => {
        const newFileList = [...bannerImage];
        newFileList.splice(index, 1);
        setBannerImage(newFileList);
    };


    console.log(bannerImage, 'tjis is ;lk')


    const Validate = (errorList) => {

        // Total Amount
        if (!state.totalAmount) {
            setErrorMessages(prev => ({ ...prev, errorTotalAmount: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorTotalAmount: false }));
        }

        // Amount Received
        if (!state.amountReceived) {
            setErrorMessages(prev => ({ ...prev, errorAmountReceived: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorAmountReceived: false }));
        }

        // Payment Type
        if (!state.paymentType) {
            setErrorMessages(prev => ({ ...prev, errorPaymentType: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorPaymentType: false }));
        }

        // Payment Method
        if (!state.paymentMethod) {
            setErrorMessages(prev => ({ ...prev, errorPaymentMethod: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorPaymentMethod: false }));
        }
    };

    const addGrant = () => {

        let errorList = [];
        Validate(errorList);

        if (errorList.length < 1) {

            const formData = new FormData();

            // append all state properties
            Object.keys(state).forEach(key => {
                if (state[key] !== undefined && state[key] !== null) {
                    formData.append(key, state[key]);
                }
            });

            formData.append('programId', programData.programId);
             formData.append('Status', null);
            setIsLoading(true);


            PostDataAPI("fdngrantcollection/add", formData).then((result) => {
                console.log(result);
                if (result.success && result.data != null) {
                    setIsLoading(false);
                    handleSuccessClose()
                } else {

                }
            });
        }


    }


    const [donorList, setDonorList] = useState([]);


    useEffect(() => {

        console.log(programData)
        if (editProgram) {
        }
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props}
        >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Add Grant</Typography>

                        <Icon
                            className={classes.closeIcon}
                            onClick={handleClose}
                            color="primary"
                        >
                            <CloseIcon />
                        </Icon>
                    </div>

                    {isLoading ? <DialogLoader></DialogLoader> : ""}
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div className={classes.content}>
                            <Grid container spacing={2}>


                                {/* Program ID */}

                                {/* Total Amount */}
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Total Amount" size={12} mandatory={true} />
                                    <InputBaseField
                                        name="totalAmount"
                                        type="number"
                                        placeholder="Total Amount"
                                        value={state.totalAmount}
                                        onChange={handleChange}
                                    />
                                    {errorMessages.errorTotalAmount && !state.totalAmount ? (
                                        <FormHelperText style={{ color: "red" }}>Please enter total amount</FormHelperText>
                                    ) : ""}
                                </Grid>

                                {/* Amount Received */}
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Amount Received" size={12} mandatory={true} />
                                    <InputBaseField
                                        name="amountReceived"
                                        type="number"
                                        placeholder="Amount Received"
                                        value={state.amountReceived}
                                        onChange={handleChange}
                                    />
                                    {errorMessages.errorAmountReceived && !state.amountReceived ? (
                                        <FormHelperText style={{ color: "red" }}>Please enter amount received</FormHelperText>
                                    ) : ""}
                                </Grid>

                                {/* Payment Type */}
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Payment Type" size={12} mandatory={true} />
                                    <SelectField
                                        name="paymentType"
                                        id="paymentType"
                                        options={[
                                            { label: "Select Payment Type", value: "" },
                                            { label: "Installment", value: "Installment" },
                                            { label: "Full Payment", value: "FullPayment" }
                                        ]}
                                        value={state.paymentType}
                                        onChange={handleChange}
                                    />
                                    {errorMessages.errorPaymentType && !state.paymentType ? (
                                        <FormHelperText style={{ color: "red" }}>Please select payment type</FormHelperText>
                                    ) : ""}
                                </Grid>

                                {/* Payment Method */}
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Payment Method" size={12} mandatory={true} />
                                    <SelectField
                                        name="paymentMethod"
                                        options={[
                                            { label: "Select Payment Method", value: "" },
                                            { label: "Bank Transfer", value: "Bank Transfer" },
                                            { label: "Cash", value: "Cash" },
                                            { label: "Cheque", value: "Cheque" },
                                            { label: "Online Payment", value: "Online" }
                                        ]}
                                        value={state.paymentMethod}
                                        onChange={handleChange}
                                    />
                                    {errorMessages.errorPaymentMethod && !state.paymentMethod ? (
                                        <FormHelperText style={{ color: "red" }}>Please select payment method</FormHelperText>
                                    ) : ""}
                                </Grid>

                                {/* Payment Reference */}
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Payment Reference" size={12} mandatory={true} />
                                    <InputBaseField
                                        name="paymentReference"
                                        type="text"
                                        placeholder="Transaction Reference (optional)"
                                        value={state.paymentReference}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                {/* Is In-Kind */}
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Is In-Kind Donation?" size={12} />
                                    <SelectField
                                        name="isInKind"
                                        options={[
                                            { label: "No", value: false },
                                            { label: "Yes", value: true }
                                        ]}
                                        value={state.isInKind}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                {/* Installment Notes */}
                                <Grid lg={12} md={12} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Installment Notes" size={12} />
                                    <InputBaseField
                                        name="installmentNotes"
                                        type="text"
                                        placeholder="Notes about installments"
                                        value={state.installmentNotes}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                {/* Collection Notes */}
                                <Grid lg={12} md={12} xs={12} sm={12} className={classes.paddingLeftRight}>
                                    <Label title="Collection Notes" size={12} />
                                    <InputBaseField
                                        name="collectionNotes"
                                        type="text"
                                        placeholder="Notes about collection follow-up"
                                        value={state.collectionNotes}
                                        onChange={handleChange}
                                    />
                                </Grid>



                            </Grid>

                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>
                                Close
                            </Button>
                            <Button onClick={addGrant} className={classes.changeBtn} >
                                Save
                            </Button>
                        </div>
                    </div>
                </div>
            </div >
        </Dialog >
    );
}

export default withSnackbar(AddGrant);
